// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6_B9M"};